import './styles.scss';

export default {
    name: 'ShapeDropdown',

    data() {
        return {
            current: '',
        };
    },

    methods: {
        chooseShape(shape) {
            this.current = shape;
            this.$ionic.popoverController.dismiss(shape);
        },
    }
};